import PropTypes from 'prop-types';
import { DoubleSlider } from '@bwoty-web/ui-kit';

import FilterButtonGroup from '../../shared/filterButtonGroup/FilterButtonGroup';

import './destinationFilter.scss';

const DestinationFilter = ({
  allBtnTotalNumberOfItems,
  filterActions,
  filterGroup,
  filterMatches,
  filterPanelIsOpen,
  filterStopsAllLabel,
}) => {
  const { selectFilterDestination, selectFilterNumberOfDestinations } = filterActions;
  const {
    destinationsLabel,
    id,
    maxNumberOfDestinations,
    minNumberOfDestinations,
    numberOfDestinationsHeading,
    options,
    selected,
    selectedMaxNumberOfDestinations,
    selectedMinNumberOfDestinations,
    toLabel,
  } = filterGroup;
  return (
    <>
      <FilterButtonGroup
        allBtnTotalNumberOfItems={allBtnTotalNumberOfItems}
        filterActions={filterActions}
        filterGroupId={id}
        filterMatches={filterMatches}
        filterStopsAllLabel={filterStopsAllLabel}
        handleSelect={selectFilterDestination}
        key={id}
        options={options}
        selectedValues={selected}
      />
      {minNumberOfDestinations !== maxNumberOfDestinations && (
        <>
          <h3 className="iw-cruise-destination-filter__n-of-destinations-heading">{numberOfDestinationsHeading}</h3>
          <DoubleSlider
            filterPluralUnitLabel={destinationsLabel}
            filterSingularUnitLabel={destinationsLabel}
            filterSliderToLabel={toLabel}
            hidden={!filterPanelIsOpen}
            key={`doubleslider-${id}`}
            maxValue={maxNumberOfDestinations}
            minValue={minNumberOfDestinations}
            onChangeComplete={(selectedValues) =>
              selectFilterNumberOfDestinations(selectedValues.lowValue, selectedValues.highValue)
            }
            selectedHighValue={
              selectedMaxNumberOfDestinations != null ? selectedMaxNumberOfDestinations : maxNumberOfDestinations
            }
            selectedLowValue={
              selectedMinNumberOfDestinations != null ? selectedMinNumberOfDestinations : minNumberOfDestinations
            }
            uniqueId={`doubleslider-${id}`}
          />
        </>
      )}
    </>
  );
};

DestinationFilter.propTypes = {
  allBtnTotalNumberOfItems: PropTypes.number.isRequired,
  filterActions: PropTypes.shape({
    selectFilterDestination: PropTypes.func.isRequired,
    selectFilterNumberOfDestinations: PropTypes.func.isRequired,
  }).isRequired,
  filterGroup: PropTypes.shape({
    destinationsLabel: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    maxNumberOfDestinations: PropTypes.number.isRequired,
    minNumberOfDestinations: PropTypes.number.isRequired,
    numberOfDestinationsHeading: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedMaxNumberOfDestinations: PropTypes.number,
    selectedMinNumberOfDestinations: PropTypes.number,
    toLabel: PropTypes.string.isRequired,
  }).isRequired,
  filterMatches: PropTypes.shape().isRequired,
  filterPanelIsOpen: PropTypes.bool.isRequired,
  filterStopsAllLabel: PropTypes.string.isRequired,
};

export default DestinationFilter;
